export const SHARE_APP_BANNER_IMAGE_SOURCE = { uri: '/images/ShareAppBannerImage.png' }
